<template>
  <div class="block__content" v-if="loaded">
    <div class="panel">
      <div class="panel-heading bg-green">
                <span class="glyphicon glyphicon-stats cap-icon_3x" style="display: inline-block;
    vertical-align: middle;margin-top: -5px;
    margin-right: 10px;"></span>
        {{ $t('Аналитика') }}
      </div>
      <div class="panel-body no-vert-pd">
        <div class="row grid-border">
          <div class="col-md-12">
            <div class="panel panel_no-shadow">
              <div class="panel-heading no-pd">
                <h3>
                                    <span class="glyphicon glyphicon-stats text-success" style="display: inline-block;
    vertical-align: middle;
    margin-right: 10px; font-size:31px; margin-top: -7px;"></span>
                  {{ $t('Аналитика от сторонних служб (Google, Яндекс)') }}
                </h3>
                <setup-toggler @input="onAnalyticsToggle" style="position: absolute;
    right: 0;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);" :checked="security.analytics"></setup-toggler>


              </div>
              <div class="panel-body no-side-pd">
                <template v-if="security.analytics">
                  <p class="text-14">
                    {{ $t('Вы можете отключить в своем кабинете Google и Яндекс аналитику.') }}</p>
                </template>
                <template v-else>
                  <p class="text-14">
                    {{ $t('Аналитика Google и Яндекс в вашем личном кабинете отключена.') }}</p>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {computed, reactive, ref, onMounted} from "vue";
import {WebFormModel} from "capitalist-shared/src/core/model";
import SetupToggler from "@/views/pages/security/setup/SetupToggler.vue";
import httpAxiosApi from "capitalist-shared/src/core/axios.errors.handle";
import {RemoteRequestState} from "capitalist-shared/src/core/remote";

class AnalyticsModel extends WebFormModel {
  loadingStatus = new RemoteRequestState();
  updatingStatus = new RemoteRequestState();

  activationSwitch(enable = true) {
    this.updatingStatus.loadStart();
    return httpAxiosApi.post('/webapi/webapi/securitysettings/updateAnalyticsSettings', {
      call: 'updateAnalyticsSettings', value: enable
    }, /*{
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }*/).then((response) => {
      this.updatingStatus.loadEnd();
      return response.data.settings;
    }, (err) => {
      this.checkAxiosError(err);
      this.updatingStatus.loadError();
      throw err;
    })
  }

  loadSettings() {
    this.loadingStatus.loadStart();
    return httpAxiosApi.get('/webapi/webapi/securitysettings').then((response) => {
      this.loadingStatus.loadEnd();
      return response.data.settings;
    }, (err) => {
      this.checkAxiosError(err);
      this.loadingStatus.loadError();
      throw err;
    })
  }
}

const model = reactive(new AnalyticsModel())
const security = ref({analytics: false})

const loaded = computed(() => {
  return model.loadingStatus.isLoaded;
})

const loadSettings = () => {
  return model.loadSettings().then((settings) => {
    security.value = {...settings};
  });
}

onMounted(() => {
  loadSettings();
})

const onAnalyticsToggle = (value: any) => {
  model.activationSwitch(value).then((settings) => {
    security.value = {...settings};
  });
}
</script>

<style scoped>

</style>


<i18n>
{
  "en": {
    "Аналитика": "Analytics",
    "Аналитика от сторонних служб (Google, Яндекс)": "Third party services analytics (Google, Yandex)",
    "Вы можете отключить в своем кабинете Google и Яндекс аналитику.": "You can disable third party services analytics (Google, Yandex) for your account.",
    "Аналитика Google и Яндекс в вашем личном кабинете отключена.": "Third party analytic services (Google and Yandex) are disabled."
  }
}
</i18n>
